export enum RequestStatus {
  created = "created",
  submitted = "Submitted",
  approved = "Approved",
  preApproved = "PreApproved",
  rejected = "Rejected",
  inProgress = "InProgress",
  inProgressC = "c",
  acceptance = "Acceptance",
  completed = "Completed",
  canceled = "canceled",
  revoked = "Revoked",
}
